
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'ToggleMode',
  props: {
    toggled: Boolean
  },
  computed: {
    themeIcon () {
      if (this.toggled) return '☀️'
      return '🌙'
    }
  },
  methods: {
    // Emits event to be caught by App component & switch Theme
    toggleMode () {
      if (this.toggled) {
        this.$emit('toggle-theme', 'light')
      } else {
        this.$emit('toggle-theme', 'dark')
      }
    }
  }
})
